export const instruments = [
  {
    id: "handpan",
    label: "01 — Pièce phare",
    name: "Handpan D-Kurd Minor",
    subtitle: "Fabricant Sound-Sculpture · 9 notes · 440 Hz",
    description:
      "Un handpan profond et élégant. Acier inoxydable, accordage Kurd mineur — idéal pour méditation, création musicale et bains sonores.",
    details: [
      { k: "Matériau", v: "Acier inoxydable" },
      { k: "Notes", v: "9 (Kurd mineur)" },
      { k: "Accordage", v: "440 Hz" },
      { k: "Inclus", v: "Sac de transport" },
    ],
    price: "1 083,60 €",
    priceOld: "1 290,00 €",
    image:
      "https://static.wixstatic.com/media/818fcb_463aad9d83a94f859dd7c170cddf8f44~mv2.png",
    accent: "#C86B52",
    link: "https://www.yogimarket.fr/product-page/d-kurd-minor-8-1",
  },
  {
    id: "gong",
    label: "02 — Présence intense",
    name: "Gong Ciel Nocturne 15\"",
    subtitle: "Fait main · Nickel argenté · 40 cm",
    description:
      "Un gong fait main au son riche et puissant. Ouvrez l'espace et installez une atmosphère profonde lors de vos pratiques sonores.",
    details: [
      { k: "Diamètre", v: "15\" / 40 cm" },
      { k: "Finition", v: "Nickel argenté" },
      { k: "Fabrication", v: "Artisanale" },
      { k: "Usage", v: "Bain sonore, cérémonie" },
    ],
    price: "775,00 €",
    image:
      "https://static.wixstatic.com/media/818fcb_7153aea33e9d4512810bdb1ca2a707b8~mv2.png",
    accent: "#8C9A86",
    link: "https://www.yogimarket.fr/product-page/gong-portatif-ciel-nocturne-arc-en-ciel-15-en-nickel-argent%C3%A9",
  },
  {
    id: "koshi",
    label: "03 — Cadeau doux",
    name: "Carillon Koshi Terra",
    subtitle: "Pyrénées françaises · Bambou & bronze",
    description:
      "Fabriqué artisanalement dans les Pyrénées. Une sonorité douce et apaisante, idéale pour offrir ou accompagner la relaxation.",
    details: [
      { k: "Origine", v: "Pyrénées · France" },
      { k: "Matériaux", v: "Bambou + bronze" },
      { k: "Accordage", v: "Terra (terre)" },
      { k: "Usage", v: "Détente, bain sonore" },
    ],
    price: "57,80 €",
    image:
      "https://static.wixstatic.com/media/818fcb_8522e3ffaf894a308fca35d4cc4c8d0e~mv2.png",
    accent: "#A8843F",
    link: "https://www.yogimarket.fr/product-page/copie-de-copie-de-koshi-ignis",
  },
  {
    id: "rainstick",
    label: "04 — Voyage sonore",
    name: "Arbre de pluie",
    subtitle: "Bois traditionnel · Cactus séché",
    description:
      "Un instrument méditatif qui recrée la douce sonorité de la pluie. Parfait pour transitions de séance et rituels d'ouverture.",
    details: [
      { k: "Matériau", v: "Bois + graines" },
      { k: "Usage", v: "Éveil, transition" },
      { k: "Taille", v: "40 — 80 cm" },
      { k: "Origine", v: "Tradition andine" },
    ],
    price: "À partir de 390 €",
    image:
      "https://static.wixstatic.com/media/818fcb_64c4d2ee05344bdf8b43a6474db326ce~mv2.png",
    accent: "#4A3320",
    link: "https://www.yogimarket.fr/category/all-products",
  },
  {
    id: "tibetan",
    label: "05 — Tradition vibratoire",
    name: "Bol tibétain chantant",
    subtitle: "7 métaux · Frappé main · Himalaya",
    description:
      "Un bol chantant aux harmoniques profondes. Alliage traditionnel de 7 métaux pour une résonance longue et enveloppante.",
    details: [
      { k: "Composition", v: "7 métaux sacrés" },
      { k: "Fabrication", v: "Martelage à la main" },
      { k: "Origine", v: "Himalaya" },
      { k: "Inclus", v: "Maillet + coussin" },
    ],
    price: "À partir de 80 €",
    image:
      "https://static.prod-images.emergentagent.com/jobs/4f598483-7a5a-40fc-9574-e1a0c8f45871/images/ba2eda985530ee2cade6846a5bb735140ef29f70a378cf76ad7c22945ab56869.png",
    accent: "#6B5537",
    link: "https://www.yogimarket.fr/category/all-products",
  },
];
